// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SharedGlobalIdUpsearchModel {
    static getAttributeTypeMap() {
        return SharedGlobalIdUpsearchModel.attributeTypeMap;
    }
}
SharedGlobalIdUpsearchModel.discriminator = undefined;
SharedGlobalIdUpsearchModel.additionalProperties = false;
SharedGlobalIdUpsearchModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "globalIdTypeCode",
        "baseName": "globalIdTypeCode",
        "type": "string"
    },
    {
        "name": "globalId",
        "baseName": "globalId",
        "type": "string"
    },
];
//# sourceMappingURL=sharedGlobalIdUpsearchModel.js.map